module.exports = __webpack_public_path__ + "img/bulk.f2556b96.svg";